import React from 'react';

export const Default: React.FC = () => {

  return (
    <div className='default'>
        <i className="bx bxl-whatsapp"></i>
        <span>Click on a chat to start messaging.</span>
    </div>
  )
}